import React, { SVGProps } from 'react'

/** Feature-local "show" glyph for the reveal toggle (matches the design prototype). */
const SvgEye = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
      d="M1 10s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6Z"
    />
    <circle
      cx={10}
      cy={10}
      r={2.5}
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.5}
    />
  </svg>
)
export default SvgEye
